export function stringifyRealtimeErrorDetail(error: unknown): string {
    if (error === null || error === undefined) {
        return 'Unknown realtime error';
    }

    if (typeof error === 'object') {
        try {
            return JSON.stringify(error);
        } catch {
            return 'Unknown realtime error';
        }
    }

    return String(error);
}
